import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
const sSGEControllerEndpoint = 'NOLS';


export class NOLSSyncAPI {

  sendUpdateOrderL4(L4Id, orderNumber) {
    return axios.get(getBackendURL() + sSGEControllerEndpoint + '/UpdateOrderL4?l4ID=' + L4Id);
  }

  sendUpdateOrderRuL4(ruL4Id, orderNumber) {
    return axios.get(getBackendURL() + sSGEControllerEndpoint + '/UpdateOrderRuL4?ruL4ID=' + ruL4Id);
  }

  sendUpdateOrderByLot(L1Id) {
    return axios.get(getBackendURL() + sSGEControllerEndpoint + '/UpdateOrderByLot?l1ID=' + L1Id);
  }

  sendUpdateOrderRuByLot(ruL1Id) {
    return axios.get(getBackendURL() + sSGEControllerEndpoint + '/UpdateOrderRuByLot?ruL1ID=' + ruL1Id);
  }

  sendUpdateOrderAll() {
    return axios.get(getBackendURL() + sSGEControllerEndpoint + '/UpdateOrderAll');
  }

  sendUpdateOrderL4All() {
    return axios.get(getBackendURL() + sSGEControllerEndpoint + '/UpdateOrderL4All');
  }

  sendUpdateOrderRuL4All() {
    return axios.get(getBackendURL() + sSGEControllerEndpoint + '/UpdateOrderRuL4All');
  }

  sendGetOrderDetailsBM(orderNumber) {
    return axios.get(getBackendURL() + sSGEControllerEndpoint + '/GetOrderDetailsBM?orderNumber=' + orderNumber);
  }

  sendGetOrderDetailsRuBM(orderNumber) {
    return axios.get(getBackendURL() + sSGEControllerEndpoint + '/GetOrderDetailsRuBM?orderNumber=' + orderNumber);
  }

}

export default NOLSSyncAPI


// WEBPACK FOOTER //
// ./src/API/NOLSSyncAPI.js